export default "__VITE_ASSET__bzfQQv3c__"